// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminMoqRules = (client) => ({
    /**
     * `POST /admin/moq-rules`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateMoqRule
     * @source packages/medusa-plugin-moq-v2/src/api/admin/moq-rules/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/moq-rules", { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/moq-rules/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDeleteMoqRule
     * @source packages/medusa-plugin-moq-v2/src/api/admin/moq-rules/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/admin/moq-rules/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/moq-rules`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListMoqRules
     * @source packages/medusa-plugin-moq-v2/src/api/admin/moq-rules/route.ts
     */
    list: (query, headers) => client.fetch("/admin/moq-rules", { method: "GET", query, headers }),
    /**
     * `GET /admin/moq-rules/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetMoqRule
     * @source packages/medusa-plugin-moq-v2/src/api/admin/moq-rules/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/moq-rules/:id", [id]), { method: "GET", query, headers }),
    /**
     * `PUT /admin/moq-rules/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdateMoqRule
     * @source packages/medusa-plugin-moq-v2/src/api/admin/moq-rules/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/moq-rules/:id", [id]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=moq-rules.js.map